import { RavenButton } from "@ravenpay/raven-bank-ui";
import Icons from "../assets/icons/icons";
import "../styles/components/ravenIconBotton.css";

// Define the allowed color types
type ButtonColors =
  | "purple-light"
  | "error-light"
  | "info-right"
  | "white-light"
  | "blue-light"
  | "green-light"
  | "orange-light"
  | "black-light"
  | "deep-green"
  | "deep-green-light"
  | "error-dark"
  | "deep-green-dark";

interface ArrowButtonProps {
  text: string;
  backgroundColor?: ButtonColors;
  textColor?: string;
  showIcon?: boolean;
  className?: string;
  btnClassName?: string;
  paddingLeft?: string;
  paddingRight?: string;
  iconColor?: string;
  onBtnClick?: () => void;
  boxShadow?: string;
  border?: string;
  icon?: any;
}

const RavenIconRightButton = ({
  text,
  icon,
  textColor = "white",
  showIcon = true,
  paddingLeft,
  paddingRight,
  onBtnClick,
  boxShadow,
  border,
  btnClassName,
}: ArrowButtonProps) => {
  return (
    <div className="raven_botton_general_wrap">
      <RavenButton
        className={`text-4 rvn_btn ${btnClassName ? btnClassName : ""}`}
        color="deep-green-light"
        style={
          {
            color: textColor,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            "--box-shadow": boxShadow || null,
            "--border": border || "none",
          } as React.CSSProperties & { [key: string]: string }
        }
        onClick={() => {
          if (onBtnClick) {
            onBtnClick();
          }
        }}
      >
        {text}
        {showIcon && (
          <div className="arrow_div_cont">
            <figure className="img-box">{icon}</figure>
          </div>
        )}
      </RavenButton>
    </div>
  );
};
export type { ButtonColors };
export default RavenIconRightButton;
